<template>
  <div>
    <app-cookie-notice />
    <router-view />
    <!--  -->
    <AppOnboard />
    <!--  -->
  </div>
</template>

<script>
import { WindowUtil } from "@/shared/utils";
import { Options, Vue } from "vue-class-component";
import AppOnboard from "./App-Onboard.vue";

@Options({
  title: "E4T Talent",
  components: { AppOnboard },
})
export default class extends Vue {
  /**
   *
   */
  mounted() {
    WindowUtil.listenToChange(document, this.$store);
  }
}
</script>

<style lang="scss">
@import "./styles.scss";
</style>
